import React, { useContext } from "react";
import { MeetingStatuses } from "../../data/MeetingStatus";
import { UserHouses } from "../../data/User";
import { SLinkContext } from "../../state/context";

/** Describes which house(s) may vote right now. */
export function votingHouseLabel(votingHouse: string | undefined): string {
  if (!votingHouse) {
    return "all houses";
  }
  if (votingHouse === UserHouses.Clergy) {
    return "House of Clergy and Bishops";
  }
  return `House of ${votingHouse}`;
}

/**
 * Persistent strip under the navbar while a session is live:
 * "In session · Item 10.3 — Heading" / "Voting open — House of Clergy".
 */
function MeetingStatusBanner() {
  const { state } = useContext(SLinkContext);
  const status = state.meetingStatus?.status;

  if (status !== MeetingStatuses.InSession && status !== MeetingStatuses.Voting) {
    return null;
  }

  const item = state.meetingStatus?.currentItem;
  const voting = status === MeetingStatuses.Voting;

  return (
    <div className={`sl-meeting-banner ${voting ? "voting" : "in-session"}`} role="status">
      <span>{voting ? `Voting open — ${votingHouseLabel(item?.votingHouse)}` : "Synod is in session"}</span>
      {item ? (
        <span className="sl-banner-item">
          Item {item.code} · {item.heading}
        </span>
      ) : (
        <span className="sl-banner-item">No current item of business</span>
      )}
    </div>
  );
}

export default MeetingStatusBanner;
